import styled from 'styled-components';

import * as Common from '../../Styles';

const Theme = Common.Theme;

export const InputGroup = styled(Common.InputGroup)``;

export const TextArea = styled(Common.TextArea)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const Dialog = styled(Common.Dialog)``;

export const DialogActions = styled(Common.DialogActions)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)`
	margin-top: -16px !important;
	padding: 1rem !important;
`;

export const CircularButton = styled(Common.CircularButton)``;

export const RadioGroup = Common.RadioGroup;

export const LocalizationProvider = styled(Common.LocalizationProvider)``;

export const DatePicker = styled(Common.DatePicker)``;

export const ResolvedDateContainer = styled.div`
	margin: 0.75rem 0;
	padding: 0.75rem 1rem;
	background-color: #fafafa;
	border: 0.5px solid #eaeaea;
	border-radius: 5px;
`;

export const ResolvedDate = styled.div`
	font-weight: 700;
	font-size: 14px;
	color: ${Theme.black};
`;

export const ResolvedDateNote = styled.div`
	margin-top: 0.25rem;
	font-size: 12px;
	color: ${Theme.darkGrey};
`;

export const AddCommentLink = styled.span`
	display: inline-block;
	margin: 0.5rem 0;
	color: ${Theme.blue};
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
`;
